function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';
import Placeholder from './Placeholder';
import { Fade } from '../../animations/Fade';
import { Badge } from '../Badge';
import { normalizeSize } from '../../utils'; // TODO: Make the placeholder passable as props

var Image = function Image(props) {
  var src = props.src,
      width = props.width,
      height = props.height,
      alt = props.alt,
      className = props.className,
      shimmer = props.shimmer,
      placeHolderText = props.placeHolderText,
      placeHolderIconWidth = props.placeHolderIconWidth,
      placeHolderIconHeight = props.placeHolderIconHeight,
      caption = props.caption;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var sizeStyles = {
    width: normalizeSize(width),
    height: normalizeSize(height)
  };
  var options = {
    threshold: 0,
    rootMargin: '200px 0px 0px 0px'
  };
  return React.createElement(InView, {
    className: className,
    as: "div",
    options: options,
    triggerOnce: true
  }, function (_ref) {
    var inView = _ref.inView,
        ref = _ref.ref;
    return React.createElement("div", {
      className: "d-inline-block p-relative",
      ref: ref,
      style: sizeStyles,
      onClick: props.onClick
    }, inView && React.createElement("div", {
      className: "d-inline-block p-absolute t-0 b-0 l-0 r-0",
      style: sizeStyles
    }, React.createElement("img", {
      alt: caption ? caption : alt,
      src: src,
      width: sizeStyles.width,
      height: sizeStyles.height,
      className: "of-cover",
      onLoad: function onLoad() {
        return setLoaded(true);
      },
      onError: function onError() {
        return setLoaded(false);
      }
    }), caption && React.createElement(Badge, {
      size: 'sm',
      className: "p-absolute r-2 b-2"
    }, caption)), React.createElement(Fade, {
      pose: loaded ? 'hidden' : 'visible',
      className: "h-100p"
    }, React.createElement(Placeholder, {
      loaded: loaded,
      width: normalizeSize(width),
      height: normalizeSize(height),
      shimmer: shimmer,
      text: placeHolderText,
      iconWidth: normalizeSize(placeHolderIconWidth),
      iconHeight: normalizeSize(placeHolderIconHeight)
    })));
  });
};

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  caption: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  placeHolderIconHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeHolderIconWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeHolderText: PropTypes.string,
  shimmer: PropTypes.bool,
  src: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
};
Image.defaultProps = {
  className: '',
  onClick: function onClick() {},
  placeHolderIconHeight: 40,
  placeHolderIconWidth: 40,
  placeHolderText: '',
  shimmer: true,
  src: ''
};
Image.displayName = 'Image';
export { Image };